export class TimedCache {
    constructor(validityInMs) {
        this.cache = new Map();
        this.validityInMs = validityInMs;
    }
    has(key) {
        if (!this.cache.has(key)) {
            return false;
        }
        const now = Date.now();
        // biome-ignore lint/style/noNonNullAssertion:
        const cachedValue = this.cache.get(key);
        const isValid = cachedValue.timestamp + this.validityInMs > now;
        if (!isValid) {
            this.cache.delete(key);
        }
        return isValid;
    }
    clear() {
        this.cache.clear();
    }
    get(key) {
        if (!this.has(key)) {
            return undefined;
        }
        // biome-ignore lint/style/noNonNullAssertion: We know there is a valid
        return this.cache.get(key).data;
    }
    set(key, value) {
        const now = Date.now();
        this.cache.set(key, { timestamp: now, data: value });
        return this;
    }
    delete(key) {
        return this.cache.delete(key);
    }
    get size() {
        return this.cache.size;
    }
    keys() {
        return this.cache.keys();
    }
}
